exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail-send-documentation .loans-detail-send-documentation{margin-top:26px;padding-right:71px}loans-detail-send-documentation .loans-detail-send-documentation.mobile{padding-right:0}loans-detail-send-documentation .loans-detail-send-documentation.mobile dd{margin-left:0;font-size:13px}loans-detail-send-documentation .loans-detail-send-documentation p:first-child{margin-bottom:21px}loans-detail-send-documentation .loans-detail-send-documentation dt{font-weight:500;color:#0072c9;font-size:13px}loans-detail-send-documentation .loans-detail-send-documentation dd{color:#666;margin-left:30px}loans-detail-send-documentation .loans-detail-send-documentation .email{color:#0072c9}loans-detail-send-documentation .remove-events{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetailSendDocumentation/loansDetailSendDocumentation.scss
// module id = 1869
// module chunks = 0